<!-- 宣传资料下载 -->
<template>
  <div class="basicStyle">
    <div style="padding: 0 20px">
      <el-tabs v-model="queryInfo.tag_id" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in tag_list"
          :key="index"
          :label="item.name"
          :name="item.id.toString()"
        >
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bg_fff">
      <div v-if="tableList && tableList.length > 0" class="fileListBox">
        <div class="fileItem" v-for="(item, index) in tableList" :key="index">
          <el-popover placement="right" trigger="click">
            <div class="downloadBox">
              <MyButton
                v-if="item.suffix == 'pdf'"
                value="预览"
                size="mini"
                type="1"
                style="display: block; margin: 10px auto"
                @click="previewFn(item)"
              ></MyButton>
              <MyButton
                value="下载"
                size="mini"
                type="1"
                style="display: block; margin: 10px auto"
                @click="download(item)"
              ></MyButton>
            </div>
            <el-button class="fileBtn" slot="reference">
              <img class="img" :src="item.img" alt="" />
              <p class="cont">{{ item.name }}</p>
            </el-button>
          </el-popover>
        </div>
      </div>
      <div v-else style="padding: 200px 0">
        <el-empty :image-size="100" description="暂无数据"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import { clearObj, deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
// 文件列表
export default {
  name: "tobFileList",
  components: { MyButton },
  data() {
    return {
      loading: false,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
      },
      tableList: [],
      timeFrame: [],
      selfnumzbsm: "",
      typeOptions: [{ value: 1, label: "宣传资料" }],
      jsjyguljsy_text: "",
      imgArr: [
        { format: ".pdf", img: require("../../assets/pdf.png"), label: "pdf" },
        {
          format: ".pptx",
          img: require("../../assets/pptx.png"),
          label: "pptx",
        },
        { format: ".xls", img: require("../../assets/xls.png"), label: "xls" },
        {
          format: ".xlsx",
          img: require("../../assets/xls.png"),
          label: "xlsx",
        },
        {
          format: ".mp4",
          img: require("../../assets/mp4.png"),
          label: "视频",
        },
        {
          format: ".zip",
          img: require("../../assets/zip.png"),
          label: "压缩包",
        },
        {
          format: ".docx",
          img: require("../../assets/docx.png"),
          label: "docx",
        },
        {
          format: ".png",
          img: require("../../assets/img.png"),
          label: "图片",
        },
        {
          format: ".jpg",
          img: require("../../assets/img.png"),
          label: "图片",
        },
        {
          format: ".unrecognized",
          img: require("../../assets/unrecognized.png"),
          label: "未识别",
        },
      ],
      tag_list: [],
    };
  },
  computed: {
    typeMap() {
      return new Map(this.typeOptions.map((item) => [item.value, item.label]));
    },
    imgMap() {
      return new Map(this.imgArr.map((item) => [item.format, item.img]));
    },
  },
  created() {
    if (this.$route.query.folder_id) {
      this.queryInfo.folder_id = this.$route.query.folder_id;
    }
    this.queryTable();
  },
  methods: {
    previewFn(e){
      console.log("previewFn", e)
      window.open( e.url, "_blank")
    },
    handleClick(e) {
      console.log("handleClick", e.name)
      this.queryInfo.tag_id = e.name
      this.queryTable()
    },
    download(row) {
      window.open(row.url, "_blank")
    },
    getFileExtension(filename) {
      // 处理空值或非字符串输入
      if (typeof filename !== 'string' || !filename.trim()) return '';
      
      // 使用正则表达式匹配最后一个点号后的内容
      const match = filename.match(/\.([^.]+)$/);
      
      // 存在扩展名则返回（自动转为小写），否则返回空字符串
      return match ? match[1].toLowerCase() : '';
    },
    // 列表数据
    async queryTable(_type) {
      let params = deepClone(this.queryInfo);
      const res = await commonApi.getTobFolderFileList(params);
      if (res.code == 200) {
        this.queryInfo.total = res.data.file_list.total;
        res.data.file_list.list.forEach((item) => {
          if (item.name) {
            item.format = item.name
              .substr(item.name.lastIndexOf("."))
              .toLowerCase();
            item.img = this.imgMap.get(item.format);
            item.img = item.img ? item.img : this.imgMap.get(".unrecognized");
          }

          if(item.url){
            item.suffix = this.getFileExtension(item.url)
          }
        });
        this.tableList = res.data.file_list.list;

        this.tag_list = res.data.tag_list;

        this.tag_list.forEach((item) => {
          if (item.is_select == 1) {
            this.queryInfo.tag_id = item.id.toString();
          }
        });

        console.log("this.tableList", this.tableList);
      } else {
        this.$message.error(res.message);
      }
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    resetQuery() {
      this.timeFrame = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
      };
      this.queryTable();
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
    .el-button {
      margin: 0 5px 10px 0;
    }
  }

  // 表格数据
  //   .table {
  //     min-height: calc(100vh - 330px);
  //     border: 1px solid #ddd;
  //     border-radius: 10px;
  //     .studentLabel {
  //       display: inline-block;
  //       padding: 5px 10px;
  //       background-color: #409eff;
  //       color: #fff;
  //       border-radius: 4px;
  //       margin: 0 5px 5px 0;
  //     }
  //   }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
/deep/.el-input-number {
  width: 250px;
}

/deep/.noData {
  padding-top: 200px;
  .text {
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .openClick {
    text-align: center;
  }
}

.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex-box {
  margin: 10px;
  display: flex;
  justify-content: space-around;
  height: 80px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
}
.activeNumber {
  color: #f40;
}
.item_a1 {
  background-color: #f5f3ff;
}
.item_a2 {
  background-color: #edfffa;
}
.item_a3 {
  background-color: #fff6ed;
}
.item_a4 {
  background-color: #ffefef;
}
/deep/.el-dialog__footer {
  text-align: center;
}

.initialLogin {
  background: #ffebeb;
  border-radius: 8px 8px 8px 8px;
  line-height: 45px;
  padding: 0 20px 0 16px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
  .initialLeft {
    color: #191b27;
    font-size: 15px;
    font-weight: 500;
  }
  .initialRight {
    height: 32px;
    width: 72px;
    background: linear-gradient(234deg, #ff6157 0%, #ff418a 100%);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    line-height: 32px;
    text-align: center;
    font-size: 13px;
    color: #ffffff;
    cursor: pointer;
  }
}

.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-top: -3px;
}
.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
.initialNum {
  font-weight: bold;
  color: red;
  font-size: 20px;
  margin-bottom: 10px;
}

.fileListBox {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  .fileItem {
    width: 120px;
    text-align: center;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    .fileBtn {
      padding: 10px;
      border: none;
      .img {
        width: 100px;
        height: 100px;
      }
      .cont {
        display: block;
        width: 100px;
        word-wrap: break-word;
        white-space: break-spaces;
      }
    }
    /deep/.downloadBox {
      text-align: center !important;
    }
  }
}

/deep/.el-tabs__nav {
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0;
}
</style>
